import { type FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

export interface ApiError {
  message: string
  code?: string
  location?: string
}

export interface ApiErrors {
  errors: ApiError[]
}

export function isApiErrors(error: unknown): error is ApiErrors {
  return (
    typeof error === 'object' &&
    error != null &&
    'errors' in error &&
    Array.isArray(error.errors) &&
    error.errors.every((errorItem) => typeof errorItem === 'object' && errorItem != null && 'message' in errorItem && typeof errorItem.message === 'string')
  )
}

export const isFetchBaseQueryError = (error: unknown): error is FetchBaseQueryError => typeof error === 'object' && error != null && 'status' in error

export const firstApiErrorMessage = (error: unknown): string | null =>
  isFetchBaseQueryError(error) && isApiErrors(error.data) ? (error.data.errors[0]?.message ?? null) : null
